import { useIntl } from 'react-intl'

import Switch from 'shared/ui/Switch'

import { Container } from './Style'

type PanelSwitchFieldProps = {
  labelId: string
  value: boolean
  onChange: (value: boolean) => void
}

const PanelSwitchField: React.FC<PanelSwitchFieldProps> = ({
  labelId,
  value,
  onChange
}) => {
  const { formatMessage } = useIntl()

  return (
    <Container>
      <span>{formatMessage({ id: labelId })}</span>

      <Switch value={value} onChange={onChange} />
    </Container>
  )
}

export default PanelSwitchField
